import { useTranslation } from "react-i18next";

import Footer from "../../core/Footer";

const SessionExpiredPage = () => {
    const { t } = useTranslation('errors');

    return (
        <div className="height-100">
            <div className="h-100 d-flex flex-column justify-content-center align-items-center">
                <img
                    alt="session expired"
                    src={`${process.env.PUBLIC_URL}/images/errors/session-expired.svg`} />
                <h1 className="c-dark-blue fw-semi-bold">{t("session_expired")}</h1>
            </div>
            <div className="footer-bottom">
                <Footer />
            </div>
        </div>);
}

export default SessionExpiredPage;